import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getItem, KEYS } from 'storage';
import {
    APPLICATION_COLUMN,
    defaultPostApprovalColumn,
    POST_APPROVAL_COLUMN,
    updateApplicationColumn,
    updatePostApprovalColumn,
    defaultApplicationColumn,
} from 'store/column/reducer';
import { INITIAL_SYSTEM_GLOBAL_DATA, UPDATE_USER } from 'store/key';
import { APPLICANT } from 'utility/lookup';
import api from 'api/call';
import { setGlobal } from 'store/global/reducer';

const useInitialize = () => {
    // blocking api here
    const dispatch = useDispatch();
    const [isInit, setInit] = useState(false);
    const [isSystemDataInit, setSystemDataInit] = useState(false);
    const isLogin = useSelector((state) => state.user.isLogin);

    // update / initialize user reducer before the application load
    useEffect(() => {
        const isLogin = getItem(KEYS.USER_IS_LOGIN, false);
        const email = getItem(KEYS.USER_EMAIL, '');
        const lastLogin = getItem(KEYS.USER_LAST_LOGIN);
        const role = getItem(KEYS.USER_ROLE, APPLICANT);
        const applicationColumn = getItem(APPLICATION_COLUMN) || defaultApplicationColumn;
        const postApprovalColumn = getItem(POST_APPROVAL_COLUMN) || defaultPostApprovalColumn;

        api.version.getBackendVersion().then((res) => {
            dispatch(
                setGlobal({
                    backendVersion: res.data,
                }),
            );
        });

        dispatch(updateApplicationColumn(applicationColumn));
        dispatch(updatePostApprovalColumn(postApprovalColumn));

        dispatch({
            type: UPDATE_USER,
            payload: {
                email,
                isLogin,
                role,
                lastLogin,
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        dispatch({
            type: INITIAL_SYSTEM_GLOBAL_DATA,
            payload: {
                callback: () => {
                    setSystemDataInit(true);
                },
            },
        });
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (isLogin !== null && isSystemDataInit) {
            setInit(true);
        }
    }, [isLogin, isSystemDataInit]);

    return isInit;
};

export default useInitialize;
